var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CardWithShadow } from "../components";
export var DoubleVideoCard = function (props) {
    var youTubeId = props.youTubeId;
    return (_jsx(CardWithShadow, __assign({ sx: __assign({ display: "flex", alignItems: "center", backgroundColor: "#000", position: 'relative', paddingBottom: '56.25%', paddingTop: 0, height: 0, overflow: 'hidden' }, props.sx) }, { children: _jsx("iframe", { style: __assign({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }, props.iframeProps), src: "https://www.youtube.com/embed/".concat(youTubeId), title: "YouTube video player", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }) })));
};
